/* eslint-disable no-invalid-this */

import ApiService, { ISSUES_API_CONTEXT, ISSUES_API_HOST } from './ApiService';

/**
 * @override
 */
class IssuesService extends ApiService {
    /**
     * constructor
     */
    constructor() {
        super({ baseURL: ISSUES_API_HOST });
    }
    /**
     * Get issues list
     * @param {Object} sort Sort
     * @param {Object} config Axios config
     * @return {Object} Response with issues
     */
    getIssues = (sort, config) => {
        if (sort.trim() !== '') {
            return this.getList(`${ISSUES_API_CONTEXT}/issues?$orderby=${sort}`, config);
        } else {
            return this.getList(`${ISSUES_API_CONTEXT}/issues`, config);
        }
    };
    /**
     * Buscar issues
     * @param {Array} search Búsqueda
     * @param {Object} config Axios config
     * @param {Object} sort Sort
     * @return {Object} Response with accounts
     */
    getSearch = (search, config, sort = false) => {
        const sortQueryParam = sort ? `&$orderby=${sort}` : '';
        return this.getList(`${ISSUES_API_CONTEXT}/issues?$search=${search}${sortQueryParam}`, config);
    };
    /**
     * Get issue
     * @param {String} uuid Issue UUID
     * @param {Object} config Axios config
     * @return {Object} Response with issue
     */
    getIssuesByUUIId = (uuid, config) => this.get(`${ISSUES_API_CONTEXT}/issues/${uuid}`, config);
    /**
     * @param {String} url Url
     * @param {Object} config Axios config
     * @return {Object} Response with list of issues
     */
    getPagination = (url, config) => this.get(`${url}`, config);
    /**
     * Actualizamos la información del usuario
     * @param {Object} issue Issue data
     * @return {Object} Response of put operation
     */
    update = issue => {
        return this.put(`${ISSUES_API_CONTEXT}/issues/${issue.uuid}`, issue);
    };
    updateValue = (issue, payload) => {
        return this.patch(`${ISSUES_API_CONTEXT}/issues/${issue.uuid}`, payload);
    };
    changeUserResponsable = payload => {
        return this.patch(`${ISSUES_API_CONTEXT}/issues/${payload.uuid}`, payload.data);
    };
    create = issue => {
        return this.post(`${ISSUES_API_CONTEXT}/issues`, issue);
    };
    /**
     * Delete issue
     * @param {String} uuid Issue id
     * @return {Object} Response of delete operation
     */
    deleteByUUIId = uuid => {
        return this.delete(`${ISSUES_API_CONTEXT}/issues/${uuid}`, {});
    };
    comment = (issue, comment) => {
        return this.post(`${ISSUES_API_CONTEXT}/issues/${issue.uuid}/comments`, comment);
    };
    getComments = uuid => {
        return this.getList(`${ISSUES_API_CONTEXT}/issues/${uuid}/comments?$orderby=created_on asc`, {});
    };
    getTypes = () => {
        return this.getList(`${ISSUES_API_CONTEXT}/issue-types`, {});
    };
    categories = () => {
        return this.getList(`${ISSUES_API_CONTEXT}/issue-categories`, {});
    };
    subcategories = () => {
        return this.getList(`${ISSUES_API_CONTEXT}/issue-subcategories`, {});
    };
    files = uuid => {
        return this.getList(`${ISSUES_API_CONTEXT}/issues/${uuid}/documents`, {});
    };

    /**
     * @override
     */
    download = (sort, config, headers) => {
        if (sort.trim() !== '') {
            return this.getDownload(`${ISSUES_API_CONTEXT}/issues/download?$orderby=${sort}`, config, { headers });
        } else {
            return this.getDownload(`${ISSUES_API_CONTEXT}/issues/download`, config, { headers });
        }
    };

    /**
     * Obtenemos a quién está asignada la issue (usuario/grupo)
     * @param {Object} issue Issue data
     * @return {String} Nombre del responsable
     */
    getUserGroupSelected = issue => {
        if (issue.group_assigned || issue.user_assigned) {
            if (issue.group_assigned) {
                return issue.group_assigned.key_name;
            } else {
                return `${issue.user_assigned.given_name} ${issue.user_assigned.family_name_1} ${
                    issue.user_assigned.family_name_2 ? issue.user_assigned.family_name_2 : ''
                }`;
            }
        } else {
            return '';
        }
    };

    /**
     * @override
     */
    upload = (issue, files, filenames) => {
        const config = {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        };

        const formData = new FormData();
        for (let i = 0; i < files.length; i++) {
            formData.append('attachment', files[i]);
            formData.append('filename', filenames[i]);
        }
        return this.post(`${ISSUES_API_CONTEXT}/issues/${issue.uuid}/documents`, formData, config);
    };

    /**
     * @override
     */
    getDocument = (uuid, uuidDocument) => {
        return this.get(`${ISSUES_API_CONTEXT}/issues/${uuid}/documents/${uuidDocument}`, {
            responseType: 'blob'
        }).then(res => res.data);
    };
}

const issueService = new IssuesService();

export default issueService;
